import {
  Box,
  Chip,
  ChipProps,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material'

type DataType = string | number

type OptionSelectProps<T extends DataType = number> = {
	optionList: {
    id: number | string
    label: string
    color?: ChipProps['color']
  }[]
  placeHolder?: string
} & SelectProps<T[]>
export const OptionSelect = <T extends DataType = number>({
	optionList,
  placeHolder,
  ...others
}: OptionSelectProps<T>) => (
  <Select
    {...others}
    multiple
    renderValue={(selected: T[]) => {
      if (selected.length === 0 && placeHolder) {
        return <em>{placeHolder}</em>
      }
      return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {selected.map((value) => {
            const option = optionList?.find((option) => option.id === value)
            return (
              <Chip
                key={value}
                label={option?.label ?? ''}
                color={option?.color ?? "success"}
                variant="filled"
                size="small"
              />
            )
          })}
        </Box>
      )
    }}
    MenuProps={{
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
      },
      style: {
        maxHeight: '50vh'
      }
    }}
  >
    {optionList.map((option) => (
      <MenuItem key={`option-${option.id}`} value={option.id}>
        {option.label}
      </MenuItem>
    ))}
  </Select>
)
